module.exports = __webpack_public_path__ + "static/img/nav_bj.bed0c2c5.png";